import { FetchUtil } from "../util/FetchUtil";
import { ILandingPageLoadRequest } from "../models/LandingPage/ILandingPageLoadRequest";
import { ILandingPageLoadResponse } from "../models/LandingPage/ILandingPageLoadResponse";
import { ILandingPageServiceEndpoint } from "../models/LandingPage/ILandingPageServiceEndpoint";
import { StringUtil } from "../util/StringUtil";

export class LandingPageService {
  constructor(private readonly _endpoint: ILandingPageServiceEndpoint) {
  }

  public async load(req: ILandingPageLoadRequest):
    Promise<ILandingPageLoadResponse> {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const pageNumber =
      req && req.page && req.page > 1 ? req.page.toString() : "";

    const page = pageNumber || "1";

    const topicList = (req.topics || [])
      .map(t => "topicIds=" + encodeURIComponent(t))
      .join("&");

    const creditTypeList = (req.creditTypes || [])
      .map(t => "creditTypeIds=" + encodeURIComponent(t))
      .join("&");

    const queryString = req ? [
      page
        ? "page=" + encodeURIComponent(page)
        : null,
        req.templates
        ? "templateIds=" + encodeURIComponent(req.templates)
        : null,
        req.specialty
        ? "specialtyId=" + encodeURIComponent(req.specialty)
        : null,
      topicList,
      creditTypeList,
      req.additionalParameters
        ? "additionalParameters=" + encodeURIComponent(req.additionalParameters)
        : null,
      req.pageId
        ? "pageId=" + encodeURIComponent(req.pageId)
        : null,
      req.subspecialty
        ? "subspecialtyId=" + encodeURIComponent(req.subspecialty)
        : null,
      req.userId
        ? "userId=" + encodeURIComponent(req.userId)
        : null,
      req.configSettingName
        ? "configsettingname=" + encodeURIComponent(req.configSettingName)
        : null
    ].filter(Boolean).join("&") : null;

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { page, query }) || "")
      .replace(/\{(?:query|page)\}/g, "");

    const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, null);

    const response = result as ILandingPageLoadResponse;
    response.requestId = req.requestId;

    return response;
  }
}
